module.exports = __webpack_public_path__ + "593507644b4be0c259ffc237ef784d44.svg";